import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import CONSTANTS, { CACHE } from '../../utils/constants';
import { getKey, staticPath } from '../../utils/common';
// import { postInWindow } from '../../utils/formPost';
import Renewal from '../subscription/renewal';
import { PAYMODE } from '../../../../common/src/constant';
import PaymodeOffer from '../offers/paymodeOffer';
import UpiPolling from '../upipolling';
import { proceedToCollectFlow } from '../../controllers/upi';

class UPIPUSH extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      errorText: '',
      isUpiPollingRequired: false,
      pollingData: {}
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.option &&
      this.props.selected &&
      this.props.option.id !== this.props.selected.id
    ) {
      if (this.state.showError) this.setState({ showError: false, errorText: '' });
    }
    if (
      getKey(prevState, 'isUpiPollingRequired', false) === true &&
      getKey(prevProps, 'isPollingRequired', false) === true &&
      getKey(this.props, 'isPollingRequired', true) === false
    ) {
      this.setState({ pollingData: {}, isUpiPollingRequired: false });
    }
  }

  submit = () => {
    const payload = {
      authMode: CONSTANTS['3D'],
      payerAccount: this.props.option.vpaId,
      paymentMode: CONSTANTS.UPI, // on saved vpas to opayment mode has to be sent as upi instead of upi push
      selectedPaymentModeId: this.props.option.id
    };
    // this.props.onOverlayValueChange(CONSTANTS.PROCESSING);
    this.props.cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, true);
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANTS.PROCESSING });

    proceedToCollectFlow(payload, this.props.cache, this.props.option.vpaId)
      .then(res => {
        this.setState(res);
      })
      .catch(err => {
        this.setState(err);
      });

    // this.props.cache
    //   .getData(CACHE.API)
    //   .pay(payload)
    //   .then(res => {
    //     const notifyMerchant = getKey(
    //       this.props.cache.getData(CACHE.MERCHANT_CONFIG),
    //       'handler.notifyMerchant',
    //       undefined
    //     );
    //     const status = getKey(res, 'body.resultInfo.resultStatus', 'F');
    //     if (status === 'S') {
    //       this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANTS.PROCESSING });
    //       const { actionUrl, content } = getKey(res, 'body.bankForm.redirectForm', {});
    //       res.body.content = content;
    //       res.body.callbackUrl = actionUrl;
    //     } else {
    //       const errorMsg = getKey(res, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR);
    //       if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
    //         notifyMerchant(CONSTANTS.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, res);
    //       }
    //       this.props.onOverlayValueChange('');
    //       this.setState({ showError: true, errorText: errorMsg });
    //     }
    //     postInWindow(res, this.props.cache);
    //   })
    //   .catch(err => {
    //     const errorMsg = getKey(err, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR);
    //     const notifyMerchant = getKey(
    //       this.props.cache.getData(CACHE.MERCHANT_CONFIG),
    //       'handler.notifyMerchant',
    //       undefined
    //     );
    //     if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
    //       notifyMerchant(CONSTANTS.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
    //     }
    //     this.props.onOverlayValueChange('');
    //     this.setState({ showError: true, errorText: errorMsg });
    //   });
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
  };

  render(
    { offers, instanceKey, isPromoAvailable, option, isActive },
    { showError, errorText, isUpiPollingRequired, pollingData }
  ) {
    const upiOffer = isPromoAvailable
      ? isActive
        ? getKey(offers, PAYMODE.UPI)
        : getKey(option, 'paymentOfferDetails')
      : null;

    return (
      <div
        className={`ptm-pay-method ptm-w100-ib ${
          isUpiPollingRequired ? 'ptm-pos-s ptm-upipolling-stretched' : ''
        }`}
        id="checkout-upi-push"
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div
          className="ptm-radio-wrap ptm-pt11"
          onClick={() => {
            this.onOptionSelect(option);
          }}
        >
          <label class="ptm-lbl">
            <input
              type="radio"
              name={`verify${instanceKey}`}
              checked={isActive}
              className={`ptm-margin0`}
            />
            <span class="ptm-checkmark" />
            <div class={`ptm-pay-method-cont`}>
              <p class={`ptm-paymode-name`}>
                <span className={`ptm-svpa-bank ptm-body-color`}>{option.displayName}</span> XX
                {option.bankAccountNo}
                <span className={`ptm-svpa-upi`}>
                  <img
                    src={`${staticPath()}/assets/images/logo-upi.svg`}
                    alt=""
                    className={`ptm-margin0`}
                  />
                </span>
              </p>
            </div>
          </label>
        </div>
        {upiOffer && <PaymodeOffer offer={upiOffer} applied={isActive} />}
        {option && isActive && <Renewal />}
        {showError ? <p className={`ptm-msg-red`}>{errorText}</p> : null}
        {pollingData && isUpiPollingRequired && pollingData.vpaID && (
          <UpiPolling pollingData={pollingData} />
        )}
      </div>
    );
  }
}

export default connect(
  'selected, cache, instanceKey, isPollingRequired',
  onChange
)(UPIPUSH);



// WEBPACK FOOTER //
// ./components/upipush/index.js